export default {
  // Navbar keys (used as nav.home, nav.shop, etc.)
  nav: {
    home: 'HOME',
    shop: 'SHOP',
    contact: 'CONTACT',
    cart: 'Cart',
  },
  navbar: {
    home: 'HOME',
    shop: 'SHOP',
    contact: 'CONTACT',
    cart: 'Cart',
  },
  // Hero
  hero_button: 'EXPLORE ROSA AMNESIA',
  hero: {
    title: "Explore Rosa Amnesia",
    subtitle: "Fast delivery in Tunisia • Payment on delivery",
    cta: "EXPLORE ROSA AMNESIA"
  },
  // Home flat keys
  home_promo_delivery: 'Fast delivery in Tunisia',
  home_promo_payment: 'Payment on delivery',
  home_new_arrivals: 'NEW ARRIVALS',
  home_new_arrivals_subtitle: 'Discover our latest creations',
  home_see_collection: 'SEE FULL COLLECTION',
  home_universe_title: "MAISON VOYOU",
  home_universe_text1: "We came from the blocks,\nwhere the nights were long\nand the dreams were louder than the city.",
  home_universe_text2: "Every piece carries a memory.\nEvery color carries a story.",
  // Notre Histoire section
  home_histoire_since: 'Since the beginning',
  home_histoire_title: 'Our Story',
  home_histoire_subtitle: 'Born in the blocks,',
  home_histoire_subtitle_accent: 'dreamers by nature.',
  home_histoire_p1: 'Voyou Rêveur is not a brand like any other. It\'s a story that begins in the streets, between the walls of the projects, where dreams are born bigger than the horizons.',
  home_histoire_p2: 'Every piece is a love letter to those who grew up with little but always dreamed big. The pink, the graffiti, the silhouettes — everything carries a meaning, a memory, an identity.',
  home_histoire_quote: '"We came from the blocks, where the nights were long and the dreams were louder than the city."',
  home_histoire_cta: 'DISCOVER THE COLLECTION',
  home_advantage_payment: 'PAYMENT ON DELIVERY',
  home_advantage_payment_desc: 'Pay when you receive your order',
  home_advantage_delivery: 'FAST DELIVERY',
  home_advantage_delivery_desc: 'Delivery throughout Tunisia in 48-72h',
  home_advantage_quality: 'PREMIUM QUALITY',
  home_advantage_quality_desc: 'Carefully selected materials',
  home_instagram_title: '#PTITVOYOU',
  home_instagram_subtitle: 'Join our community',
  home_instagram_button: 'FOLLOW @PTITVOYOU',
  // Boutique flat keys
  boutique_loading: 'Loading products...',
  boutique_title: 'SHOP',
  boutique_subtitle: 'Discover our complete collection',
  boutique_filters: 'FILTERS',
  boutique_sizes: 'SIZES',
  boutique_colors: 'COLORS',
  boutique_price: 'PRICE',
  boutique_reset: 'Reset',
  boutique_products_count: '{{count}} products',
  boutique_no_results: 'No products match your criteria',
  // Nested keys (kept for compatibility)
  home: {
    newArrivals: "NEW ARRIVALS",
    newArrivalsSubtitle: "Discover our latest creations",
    seeCollection: "SEE FULL COLLECTION",
    universeTitle: "THE P'TIT VOYOU UNIVERSE",
    universeText1: "P'tit Voyou is more than a brand, it's an attitude. Born from the desire to create unique pieces that reflect the rebellious and dreamy spirit of a generation that refuses to conform.",
    universeText2: "Each creation is designed to express your personality, your freedom, your way of seeing the world. Because style is not just about following trends, it's about creating your own.",
    paymentTitle: "PAYMENT ON DELIVERY",
    paymentDesc: "Pay when you receive your order",
    deliveryTitle: "FAST DELIVERY",
    deliveryDesc: "Delivery throughout Tunisia in 48-72h",
    qualityTitle: "PREMIUM QUALITY",
    qualityDesc: "Carefully selected materials",
    instagramTitle: "#PTITVOYOU",
    instagramSubtitle: "Join our community",
    followButton: "FOLLOW @PTITVOYOU"
  },
  boutique: {
    title: "SHOP",
    subtitle: "Discover our complete collection",
    filters: "FILTERS",
    sizes: "SIZES",
    colors: "COLORS",
    price: "PRICE",
    reset: "Reset",
    loading: "Loading products...",
    productsCount: "{{count}} products",
    noResults: "No products match your criteria"
  },
  produit: {
    home: "Home",
    shop: "Shop",
    size: "SIZE",
    color: "COLOR",
    quantity: "QUANTITY",
    addToCart: "ADD TO CART",
    description: "DESCRIPTION",
    qualityBullet: "Premium quality materials",
    fitBullet: "Regular fit",
    designBullet: "Unique design",
    deliveryTitle: "DELIVERY & RETURNS",
    deliveryText: "Free delivery in Tunisia for orders over 150 TND. Free returns within 14 days.",
    youMightLike: "YOU MIGHT ALSO LIKE",
    addedToCart: "Product added to cart"
  },
  panier: {
    title: "CART",
    emptyCart: "Your cart is empty",
    emptyCartDesc: "Add products to get started",
    size: "Size",
    color: "Color",
    remove: "Remove",
    summary: "SUMMARY",
    subtotal: "Subtotal",
    shipping: "Shipping",
    shippingFree: "Free",
    total: "TOTAL",
    placeOrder: "PLACE ORDER",
    continueShopping: "Continue shopping",
    securePayment: "Secure payment",
    fastDelivery: "Fast delivery",
    freeReturns: "Free returns"
  },
  commande: {
    title: "COMPLETE YOUR ORDER",
    shippingInfo: "SHIPPING INFORMATION",
    firstName: "FIRST NAME",
    lastName: "LAST NAME",
    phone: "PHONE",
    address: "ADDRESS",
    city: "CITY",
    notes: "ORDER NOTES (OPTIONAL)",
    paymentMethod: "PAYMENT METHOD",
    paymentOnDelivery: "Payment on delivery",
    paymentOnDeliveryDesc: "Pay in cash when you receive your order",
    confirmOrder: "CONFIRM ORDER",
    yourOrder: "YOUR ORDER",
    subtotal: "Subtotal",
    shipping: "Shipping",
    shippingFree: "Free",
    total: "TOTAL"
  },
  confirmation: {
    title: "ORDER CONFIRMED",
    thankYou: "Thank you for your order!",
    orderNumber: "Order number",
    phoneConfirm: "Phone confirmation",
    phoneConfirmDesc: "We will call you to confirm your order",
    fastDelivery: "Fast delivery",
    fastDeliveryDesc: "Delivery in 48-72h throughout Tunisia",
    paymentOnDelivery: "Payment on delivery",
    paymentOnDeliveryDesc: "Pay in cash when you receive",
    continueShopping: "CONTINUE SHOPPING",
    backToHome: "BACK TO HOME"
  },
  contact: {
    title: "CONTACT US",
    subtitle: "We're here to answer all your questions",
    fullName: "FULL NAME",
    email: "EMAIL",
    phone: "PHONE",
    message: "MESSAGE",
    send: "SEND MESSAGE",
    successMessage: "Message sent successfully!",
    information: "INFORMATION",
    phoneLabel: "PHONE",
    emailLabel: "EMAIL",
    hours: "HOURS",
    hoursText: "Mon-Sat: 9am-6pm\nSunday: Closed",
    followUs: "FOLLOW US",
    communityText: "Join our community and stay updated on our latest news"
  },
  footer: {
    navigation: "NAVIGATION",
    home: "Home",
    shop: "Shop",
    contact: "Contact",
    information: "INFORMATION",
    delivery: "Delivery & Returns",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    followUs: "FOLLOW US",
    brandText: "North Africain Reveur",
    rights: "All rights reserved"
  }
};
